// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/Auth/AuthProvider';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { store } from './redux/store';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <AuthProvider>
    <BrowserRouter>
      <Provider store={store}>
        <CssBaseline />
        <App />
      </Provider>
    </BrowserRouter>
  </AuthProvider>,
  // </React.StrictMode>
);
